<div class="container-fluid no-gutters">
  <div class="d-flex justify-content-between align-items-center">
    <h2 class="title">News</h2>
    <button class="btn btn-add button btn-primary" (click)="addNew()">Add New</button>
  </div>
  <div class="mt-2" style="font-size: 14px;">
    <mat-card>
      <div class="row w-100 m-0" [formGroup]="newsFormGroup">
        <div class="d-flex flex-column col-md-6 col-lg-2">
          <span>Bulk Action</span>
          <mat-form-field appearance="outline">
            <mat-label class="m-0">Select</mat-label>
            <mat-select [(value)]="action">
              <mat-option value="delete"> Delete </mat-option>
              <mat-option value="publish"> Publish </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-4 col-lg-2 d-flex align-items-center justify-content-center">
          <button class="btn btn-add btn-outline-primary action-filter" style="height: 43px; margin-top: 12px;" (click)="bulkAction()">Action</button>
        </div>
        <div class="col-md-6 col-lg-4 d-flex flex-column">
          <span>Title</span>
          <mat-form-field appearance="outline" style="width: 90%">
            <input matInput maxlength="100" formControlName="title" [maxlength]="100">
            <mat-hint align="end">{{newsFormGroup.controls.title.value.length || 0}} / 100</mat-hint>
            <!-- <mat-error>{{sectionForm.controls.title.errors?.message}}</mat-error> -->
          </mat-form-field>
        </div>
        <div class="d-flex flex-column col-md-6 pr-2 col-lg-2">
          <span>Status</span>
          <mat-form-field appearance="outline" >
            <mat-select formControlName="status">
              <mat-option value=""> All </mat-option>
              <mat-option value="1"> Published </mat-option>
              <mat-option value="0"> Draft </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-5 px-2 col-lg-2 d-flex align-items-center justify-content-center">
          <button class="btn btn-add btn-outline-primary action-filter" style="height: 43px; margin-top: 12px;" (click)="filter()">Filter</button>
        </div>
      </div>
    </mat-card>
  </div>
  <div class="">
    <table mat-table [dataSource]="dataSource" matSort class="w-100 mt-4" (matSortChange)="sortData($event)">

      <!-- Title column -->
      <ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef class="bold-header pr-2"> <mat-checkbox #checkAll (change)="checkedAll()" [color]="'#005cb9'"></mat-checkbox> </th>
        <td mat-cell *matCellDef="let row" class="title-column pr-2 text-center"> 
          <mat-checkbox [checked]="row.isChecked" (change)="checkOne(row.id)"></mat-checkbox>
        </td>
      </ng-container>

      <!-- Title column -->
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="bold-header px-2" style="width: 40%;"> Title </th>
        <td mat-cell *matCellDef="let row" class="title-column p-2"> {{row.title}} </td>
      </ng-container>

      <!-- Author column -->
      <ng-container matColumnDef="author">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-2"> Author </th>
        <td mat-cell *matCellDef="let row" class="p-2"> {{row.author}} </td>
      </ng-container>

      <!-- Publish column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-2"> Status </th>
        <td mat-cell *matCellDef="let row" class="p-2"> {{row.publish ? 'Publish' : 'Draft'}} </td>
      </ng-container>

      <!-- Last Updated column -->
      <ng-container matColumnDef="lastUpdated">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-2"> Last Updated </th>
        <td mat-cell *matCellDef="let row" class="p-2"> {{row.lastUpdated}} </td>
      </ng-container>

      <!-- Action column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Action </th>
        <td mat-cell *matCellDef="let row" style="text-align: center;">
          <div class="d-flex justify-content-center align-items-center">
            <span class="material-icons px-2 action" *ngIf="row.publish" [matTooltip]="'Hidden'" (click)="active(row.id, !row.publish)"> visibility </span>
            <span class="material-icons px-2 action" *ngIf="!row.publish" [matTooltip]="'Show'" (click)="active(row.id, !row.publish)"> visibility_off </span>
            <span class="material-icons action edit px-2" (click)="edit(row.id)" [matTooltip]="'Edit'"></span>
            <i class="fa fa-trash px-2 action delete" aria-hidden="true" [matTooltip]="'Remove'"
              (click)="deleteNews(row?.id)" style="cursor: pointer; font-size:23px"></i>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <app-ngx-mat-paginator class="w-100" *ngIf="!!dataSource && dataSource.data.length > 0"
      [requestOption]="requestOption" (requestOptionChange)="onChangeRequestOption($event)"></app-ngx-mat-paginator>
  </div>
</div>